import {BaseExportsController} from './base-controller';
import moment from "moment";

class BillingExportsController extends BaseExportsController {

    constructor($scope, $rootScope, $injector) {
        super($scope, $rootScope, $injector);
        this.deposits = {
            states: []
        };

        this.exportsGrouped = [
            {
                key: 'general',
                label: 'Allgemein',
                exports: [
                    {
                        label: 'Jahresabrechnung',
                        view: 'year_billing_summary',
                        description: 'Exports the yearly billing summary',
                        path: 'exports/billing/yearly-summary',
                        fileName: 'Yearly billing summary.xlsx',
                        fields: [
                            'start_date',
                            'end_date'
                        ],
                        activator: () => {
                            const startDate = new Date();
                            startDate.setDate(1);
                            startDate.setMonth(0);
                            const endDate = new Date();
                            endDate.setDate(31);
                            endDate.setMonth(11);

                            this.currentData = {
                                start_date: startDate,
                                end_date: endDate
                            }
                        }
                    },
                    {
                        label: 'Kumulierte Werte',
                        view: 'service_fee_export',
                        description: 'Cumulated values for positions and payments',
                        path: 'exports/billing/service-fee',
                        fileName: 'Cumulative-Values.pdf',
                        fields: [
                            'start_date',
                            'end_date'
                        ],
                        activator: () => {
                            const startDate = new Date();
                            startDate.setDate(1);
                            startDate.setMonth(0);
                            const endDate = new Date();
                            endDate.setDate(31);
                            endDate.setMonth(11);
                            50
                            this.currentData = {
                                start_date: startDate,
                                end_date: endDate
                            }
                        }
                    },
                    {
                        label: 'Statistik nach Tag',
                        view: 'daily_statistics',
                        description: 'Tagesstatistiken für gewählten Zeitraum',
                        path: 'exports/billing/statistics/by-day',
                        fileName: 'Tagesstatistik.xlsx',
                        fields: [
                            'start_date',
                            'end_date'
                        ],
                        fileNameFormatter(data) {
                            let out

                            const startDateString = moment(data.start_date).format('DDMMYYYY')
                            const endDateString = moment(data.end_date).format('DDMMYYYY')
                            if (startDateString !== endDateString) {
                                out = `Mehrtagesstatistik_${startDateString}-${endDateString}`
                            } else {
                                out = `Tagesstatistik_${startDateString}`
                            }

                            out += `__${moment().format('DDMMYYYY-HHmm')}`

                            return out + '.xlsx';
                        },
                        activator: () => {
                            this.currentData = {
                                'start_date': new Date(),
                                'end_date': new Date()
                            }
                        }
                    },
                    {
                        label: 'Verkaufsliste nach Rechnung',
                        view: 'sold_statistics_by_invoice',
                        description: 'Verkaufsliste für gewählten Zeitraum',
                        path: 'exports/billing/statistics/sold-by-invoice',
                        fileName: 'Verkaufsliste.xlsx',
                        fields: [
                            'start_date',
                            'end_date'
                        ],
                        fileNameFormatter(data) {
                            let out = 'Verkaufsliste_';

                            const startDateString = moment(data.start_date).format('DDMMYYYY')
                            const endDateString = moment(data.end_date).format('DDMMYYYY')
                            if (startDateString !== endDateString) {
                                out += `${startDateString}-${endDateString}`
                            } else {
                                out = `${startDateString}`
                            }

                            out += `__${moment().format('DDMMYYYY-HHmm')}`

                            return out + '.xlsx';
                        },
                        activator: () => {
                            this.currentData = {
                                'start_date': new Date(),
                                'end_date': new Date()
                            }
                        }
                    },
                ]
            },
            {
                key: 'cash-register',
                label: 'Kassen',
                exports: [
                    {
                    label: 'Hundt-Systeme',
                    view: 'hundt_systeme_export',
                    description: 'Address Export für Kassen Hundt',
                    path: 'exports/billing/hundt-systeme',
                    fileName: 'kassen-hundt.csv',
                    fields: [
                        'start_date',
                        'end_date',
                        'states'
                    ],
                    activator: () => {
                        this.currentData = {
                            ...this.defaultGuestlistDates,
                            states: _.cloneDeep(this.userStore.state.company.settings.exports.billing_hundt_systeme_default_states)
                        }
                    }
                },
                    {
                        label: 'Schultes Kassen',
                        view: 'schultes_kassen_export',
                        description: 'Address Export für Schultes Kassen',
                        path: 'exports/billing/schultes-kassen',
                        fileName: 'schultes-kassen.csv',
                        fields: [
                            'start_date',
                            'end_date',
                            'states'
                        ],
                        activator: () => {
                            this.currentData = {
                                ...this.defaultGuestlistDates,
                                states: _.cloneDeep(this.userStore.state.company.settings.exports.billing_hundt_systeme_default_states)
                            }
                        }
                    },
                    {
                        label: 'Ilass Kassen',
                        view: 'ilass_kassen_export',
                        description: 'Address Export für Ilass Kassen',
                        path: 'exports/billing/ilass-kassen',
                        fileName: 'ilass-kassen.xlsx',
                        fields: [
                            'start_date',
                            'end_date',
                            'states'
                        ],
                        activator: () => {
                            this.currentData = {
                                ...this.defaultGuestlistDates,
                                states: _.cloneDeep(this.userStore.state.company.settings.exports.billing_hundt_systeme_default_states)
                            }
                        }
                    },
                    {
                        label: 'Matrix Kassen (Hotel)',
                        view: 'matrix_hotel_kassen_export',
                        description: 'Address Export für Matrix Kassen Hotel Schnittstelle',
                        path: 'exports/billing/matrix-kassen-hotel',
                        fileName: 'inhouse.dat',
                        fields: [
                            'start_date',
                            'end_date',
                            'states'
                        ],
                        activator: () => {
                            this.currentData = {
                                ...this.defaultGuestlistDates,
                                states: _.cloneDeep(this.userStore.state.company.settings.exports.billing_hundt_systeme_default_states)
                            }
                        }
                    }]
            },
            {
                key: 'Datev',
                label: 'DATEV',
                exports: [
                    {
                        label: 'Datev Debitors',
                        view: 'datev_debitors',
                        description: 'Export Debitors for Datev',
                        path: 'exports/billing/datev/debitors',
                        fileName: 'datev_debitors.csv',
                        fields: [
                            'base_time'
                        ],
                        fileNameFormatter(data) {
                            let out = '';

                            if (data.base_time) {
                                const baseTimeString = moment(data.base_time).format('DDMMYYYY')
                                out = `${baseTimeString}`
                            }

                            out += `_datev_debitors_${moment().format('DDMMYYYY-HHmm')}`

                            return out + '.csv';
                        },
                        activator: () => {
                            this.currentData = {
                                base_time: null
                            }
                        }
                    },
                    {
                        label: 'Datev Payments',
                        view: 'datev_payments',
                        description: 'Export Payments for Datev',
                        path: 'exports/billing/datev/payments',
                        fileName: 'datev_payments.csv',
                        fields: [
                            'start_date',
                            'end_date'
                        ],
                        fileNameFormatter(data) {
                            let out = '';

                            const startDateString = moment(data.start_date).format('DDMMYYYY')
                            const endDateString = moment(data.end_date).format('DDMMYYYY')
                            if (startDateString !== endDateString) {
                                out += `${startDateString}-${endDateString}`
                            } else {
                                out = `${startDateString}`
                            }

                            out += `_datev_payments_${moment().format('DDMMYYYY-HHmm')}`

                            return out + '.csv';
                        },
                        activator: () => {
                            this.currentData = {
                                'start_date': new Date(),
                                'end_date': new Date()
                            }
                        }
                    },
                    {
                        label: 'Datev Invoiced Positions',
                        view: 'datev_invoiced_positions',
                        description: 'Export Invoiced positions for Datev',
                        path: 'exports/billing/datev/invoiced-positions',
                        fileName: 'datev_invoiced_positions.csv',
                        fields: [
                            'start_date',
                            'end_date'
                        ],
                        fileNameFormatter(data) {
                            let out = '';

                            const startDateString = moment(data.start_date).format('DDMMYYYY')
                            const endDateString = moment(data.end_date).format('DDMMYYYY')
                            if (startDateString !== endDateString) {
                                out += `${startDateString}-${endDateString}`
                            } else {
                                out = `${startDateString}`
                            }

                            out += `_datev_invoiced_positions_${moment().format('DDMMYYYY-HHmm')}`

                            return out + '.csv';
                        },
                        activator: () => {
                            this.currentData = {
                                'start_date': new Date(),
                                'end_date': new Date()
                            }
                        }
                    },
                    {
                        label: 'Datev Original File Type',
                        view: 'datev_original_file',
                        description: 'Datev Original export file type',
                        path: 'exports/billing/datev/original',
                        fileName: 'datev_original.csv',
                        fields: [
                            'start_date',
                            'end_date'
                        ],
                        fileNameFormatter(data) {
                            let out = 'EXTF_';

                            const startDateString = moment(data.start_date).format('DDMMYYYY')
                            const endDateString = moment(data.end_date).format('DDMMYYYY')
                            if (startDateString !== endDateString) {
                                out += `${startDateString}-${endDateString}`
                            } else {
                                out = `${startDateString}`
                            }

                            out += `_datev_original_${moment().format('DDMMYYYY-HHmm')}`

                            return out + '.csv';
                        },
                        activator: () => {
                            this.currentData = {
                                'start_date': new Date(),
                                'end_date': new Date()
                            }
                        }
                    }
                ]
            },
            {
                key: 'css',
                label: 'CSS',
                exports: [
                    {
                        label: 'CSS eGecko',
                        view: 'css_egecko',
                        description: 'Export Buchungssätze für eGecko',
                        path: 'exports/billing/css/stapel',
                        fileName: 'egecko_belege.xml',
                        fields: [
                            'start_date',
                            'end_date'
                        ],
                        fileNameFormatter(data) {
                            let out = '';

                            if (data.base_time) {
                                const baseTimeString = moment(data.base_time).format('DDMMYYYY')
                                out = `${baseTimeString}`
                            }

                            out += `_css_egecko_${moment().format('DDMMYYYY-HHmm')}`

                            return out + '.xml';
                        },
                        activator: () => {
                            this.currentData = {
                                'start_date': new Date(),
                                'end_date': new Date()
                            }
                        }
                    }
                ]
            },
        ];

        this.prepareStates();
    }

    prepareStates() {
        this.depositService.getRemoteDeposit('rsvps', 'states', []).then((value) => {
            _.each(value, (v, k) => {
                this.deposits.states.push({
                    value: k,
                    label: v
                });
            });
        });
    }

    getSideNavActions() {
        if (!this.exportsGrouped) {
            return [];
        }
        return this.exportsGrouped.reduce((out, entry) => {
            return out.concat(entry.exports)
        }, [])
    }
}


angular.module('festzelt-os.exports')
    .controller('BillingExportsController', BillingExportsController);



// WEBPACK FOOTER //
// ./src/app/pages/exports/controllers/billing-controller.js